import { Injectable } from '@angular/core';

import type { QuotaStatusResponse } from '@reach/interfaces/quotas/quota.responses';
import type { QuotaTypeEnum } from '@reach/interfaces/quotas/quota-type.enum';

import { BaseApiService } from '~app-client/api/_internal';

@Injectable({ providedIn: 'root' })
export class QuotaApiService extends BaseApiService {
	protected commonPath = ['quotas'];

	public async getUserQuota<const T extends QuotaTypeEnum = QuotaTypeEnum>(
		types?: readonly T[]
	): Promise<QuotaStatusResponse<T>> {
		const params = {
			t: `${this.cacheTimer}`,
			...(types != null ? { types: [...types] } : {}),
		};
		return await this.http.get<QuotaStatusResponse<T>>(this.url('status'), params);
	}
}
